import { EU_FILE_UPLOAD, EU_FILE_UPLOAD_SUCESSFULLY } from 'Action/types';

const initialState = {
  euFileUploadData: null,
  euFileUploadStatus: null,
};

export default (state: any, action: any) => {
  if (!state) {
    state = initialState;
  }

  switch (action.type) {
    case EU_FILE_UPLOAD:
      return {
        ...state,
        euFileUploadData: action.payload,
      };

    case EU_FILE_UPLOAD_SUCESSFULLY:
      return {
        ...state,
        euFileUploadStatus: action.payload,
      };
    default:
      return state;
  }
};
